import {
  MenuItem,
  Select,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  TableBody,
  TableHead,
  Grid,
  Paper,
  Typography,
  Chip,
  IconButton,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { Add, GetApp } from "@material-ui/icons";
import { useHistory, useRouteMatch } from "react-router";
import React from "react";
import { SearchTextField } from "../../../components/TextField";
import { useTablesStyle } from "../../../styles/tableStyle";
const Employees = () => {
  const tableStyle = useTablesStyle();
  const history = useHistory();
  const { url } = useRouteMatch();
  return (
    <Paper style={{ width: "100%" }}>
      <Grid item container xs={12} style={{ margin: "auto" }} spacing={2}>
        {/* employee title section */}
        <Grid item container xs={12} justifyContent="space-between">
          <Grid item xs={6} container direction="row">
            <Typography style={{ marginLeft: "10px" }} variant="button">
              کارمند ها
            </Typography>
            <Chip
              label={"5"}
              color="primary"
              style={{ width: "50px", fontSize: "15px" }}
              size="small"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={6} justifyContent="flex-end" container direction="row">
            <IconButton
              color="primary"
              onClick={() => {
                history.push(`${url}/newEmployeeForm`);
              }}
            >
              <Add />
            </IconButton>
            <IconButton color="primary">
              <GetApp />
            </IconButton>
          </Grid>
        </Grid>
        {/* employee search and table section */}
        <Grid item style={{ margin: "auto" }} spacing={2} container xs={12}>
          <Grid item xs={12} sm={8}>
            <SearchTextField />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel>وضعیت</InputLabel>
              <Select label="وضعیت">
                <MenuItem>همه</MenuItem>
                <MenuItem>فعال</MenuItem>
                <MenuItem>غیر فعال</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        {/* employee table section */}
        <Grid item container xs={12} spacing={2} style={{ margin: "auto" }}>
          <TableContainer className={tableStyle.tableContainer}>
            <Table>
              <TableHead>
                <TableRow className={tableStyle.TableRow}>
                  {TableHeadCells.map((item, index) => {
                    return (
                      <TableCell key={index} width={item.width}>
                        {item.title}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody></TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Employees;

const TableHeadCells = [
  { title: "شناسه", width: "10%" },
  { title: "نام", width: "15%" },
  { title: "آدرس ایمیل", width: "15%" },
  { title: "گروه کاربران", width: "15%" },
  { title: "تاریخ", width: "15%" },
  { title: "وضعیت", width: "20%" },
  { title: "مشاهده", width: "10%" },
];
